window.copyToClipboard = function (copyText) {
    const elem = document.createElement('textarea');
    elem.value = copyText;
    document.body.appendChild(elem);
    /* Select the textarea field */
    elem.select();
    elem.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
    document.body.removeChild(elem);
    toastr.success('Copied to Clipboard !');
}